const MODULE_NAME = 'fulcrum/containers/App/Notification'
const UPDATE_TIMEOUT = 'fulcrum/containers/App/Notification/UPDATE_TIMEOUT'
const UPDATE_TYPE = 'fulcrum/containers/App/Notification/UPDATE_TYPE'
const UPDATE_MESSAGE = 'fulcrum/containers/App/Notification/UPDATE_MESSAGE'
const UPDATE_ACTIVE = 'fulcrum/containers/App/Notification/UPDATE_ACTIVE'
const CLEAR_TYPE = 'fulcrum/containers/App/Notification/CLEAR_TYPE'
const CLEAR_MESSAGE = 'fulcrum/containers/App/Notification/CLEAR_MESSAGE'
const CLEAR_ACTIVE = 'fulcrum/containers/App/Notification/CLEAR_ACTIVE'

const NOTIFICATION_START = 'fulcrum/containers/App/Notification/NOTIFICATION_START'
const NOTIFICATION_END = 'fulcrum/containers/App/Notification/NOTIFICATION_END'

const DEFAULT_ERROR_CODE = 'C000'
const WARNING_CODE = 'W200'
const DEFAULT_NOTIFICATION_ACTION = 'fulcrum/containers/App/Notification/DEFAULT_NOTIFICATION_ACTION'

const NOTIFICATION = Object.freeze({
  INFO: {
    value: 'info',
    priority: 1
  },
  SUCCESS: {
    value: 'success',
    priority: 2
  },
  ERROR: {
    value: 'error',
    priority: 3
  },
  FINISHED: {
    value: 'finished',
    priority: 4
  },
})

export {
  DEFAULT_ERROR_CODE,
  WARNING_CODE,
  DEFAULT_NOTIFICATION_ACTION,
  MODULE_NAME,
  NOTIFICATION,
  NOTIFICATION_START,
  NOTIFICATION_END,
  UPDATE_TIMEOUT,
  UPDATE_TYPE,
  UPDATE_MESSAGE,
  UPDATE_ACTIVE,
  CLEAR_TYPE,
  CLEAR_MESSAGE,
  CLEAR_ACTIVE,
}
